// extracted by mini-css-extract-plugin
export default {"returnButton":"SignupModal_returnButton__zwGWX","footer":"SignupModal_footer__3JO8G","loginLink":"SignupModal_loginLink__ZwKxI"};